module.exports = {
  paperPackage: {
    title: "试卷包列表页",
    requiredParams: {
      courseChapterId: "教研课程包id",
      courseId: "运营课程包id"
    },
    optionalParams: {}
  },
  courseStudy: {
    title: "课程学习页",
    requiredParams: {
      courseType: "课程类型",
      courseId: "运营课程包id"
    },
    optionalParams: {
      courseChapterId: "校验课程包id或者原子课id"
    }
  },
  coursePackage: {
    title: "教研课程包页",
    requiredParams: {
      courseId: "运营课程包id"
    },
    optionalParams: {}
  },
  studyIndex: {
    title: "我的课程",
    requiredParams: {},
    optionalParams: {}
  },
  courseSearch: {
    title: "课程搜索",
    requiredParams: {},
    optionalParams: {}
  },
  courseForbidden: {
    title: "课程禁用页",
    requiredParams: {},
    optionalParams: {}
  },
  courseFreeze: {
    title: "课程已冻结",
    requiredParams: {},
    optionalParams: {}
  },
  coursePast: {
    title: "课程已过期",
    requiredParams: {
      courseId: "课程id"
    },
    optionalParams: {}
  },
  topicStudy: {
    title: "习题",
    requiredParams: {
      // operateCourseId: "运营课程包id"
    },
    optionalParams: {
      // coursePackageId: "课程包id",
      // testPaperNo: "试卷编号",
      // atomicCourseId: "原子课id",
      // knowledgeId: "知识点Id",
      // errorOrCorrect: "1看全部，2只看正确，3只看错误", //查看详情的时候用
      // questionId:
      //   "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)"
    }
  },
  topicStudyResult: {
    title: "习题结果",
    requiredParams: {
      // operateCourseId: "运营课程包id"
    },
    optionalParams: {
      // coursePackageId: "课程包id",
      // testPaperNo: "试卷编号",
      // atomicCourseId: "原子课id",
      // knowledgeId: "知识点Id"
    }
  }
};
